import {JacksonType, JsonIdentityInfo} from "@sonner/jackson-service-v2";
import {SonnerBaseEntity} from "../modules/core/classes/sonner.base.entity";
import {Municipio} from "./municipio";

@JacksonType("UnidadeItem")
@JsonIdentityInfo()
export class UnidadeItem extends SonnerBaseEntity {

  id: number;

  ativa: boolean = false;

  @JacksonType("Municipio")
  municipio: Municipio;

  nome: string;

  sigla: string;
}
